import { UserRailyOfficerListItem } from "../../../../../common/services/user/raily-officer/list/user-raily-officer-list";
import UserStatus from "../../../../../common/types/user-status";
import phoneNumberService from "../../../../../common/utils/phone-number/phone-number.service";
import RailyOfficerListingItem from "./types/raily-officer-listing-item";

const createMobilePhones = (
  listItem: UserRailyOfficerListItem,
): RailyOfficerListingItem["phoneNumbers"] => {
  const phoneNumbers: RailyOfficerListingItem["phoneNumbers"] = [
    phoneNumberService.getLabel(listItem.phoneNumber),
  ];

  if (listItem.alternativePhoneNumber) {
    phoneNumbers.push(
      phoneNumberService.getLabel(listItem.alternativePhoneNumber),
    );
  }

  return phoneNumbers;
};

const createListingItem = (
  listItem: UserRailyOfficerListItem,
): RailyOfficerListingItem => {
  const phoneNumbers = createMobilePhones(listItem);

  return {
    uuid: listItem.uuid,
    firstName: listItem.firstName,
    lastName: listItem.lastName,
    username: listItem.username,
    email: listItem.email,
    phoneNumbers,
    status: !listItem.removalDate ? UserStatus.ACTIVE : UserStatus.DELETED,
  };
};

const createListingItems = (
  listItems: UserRailyOfficerListItem[],
): RailyOfficerListingItem[] => {
  return listItems.map(createListingItem);
};

const railyOfficerListingItemFactory = {
  createListingItems,
};

export default railyOfficerListingItemFactory;
